query GetLeadPrimaryContactDripSequenceProgressions($leadId: ID!) {
    lead(id: $leadId) {
        id
        contacts {
            edges {
                node {
                    id
                    name
                    htmlUrl
                    dripProgressions {
                        id
                        nextEditionSendTime
                        numEditionsSent
                        campaign {
                            id
                            name
                            status
                            htmlUrlPath
                            editions {
                                totalCount
                            }
                        }
                        nextEdition {
                            id
                            name
                            emailTemplate {
                                id
                            }
                        }
                    }
                }
            }
        }
    }
}
